import Component from '@glimmer/component'
import { resetOutletScroll } from 'teacher-ui-client/modifiers/reset-scroll'
import type Student from 'teacher-ui-client/models/student'
import { FilteringSelect } from 'teacher-ui-client/components/filtering-select'
import { t } from 'ember-intl'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import { hasId } from 'teacher-ui-client/utils/type-guards'

interface Args {
  students?: Student[]
  excludedStudent?: Student
  includeSelectAll?: boolean
  classRouteName?: string
  studentRouteName?: string
}

export class StudentSearchComponent extends Component<Args> {
  @service router!: RouterService

  get studentItems() {
    return (
      this.args.students
        ?.filter(hasId)
        .map((student) => ({ id: student.id, title: student.fullName }))
        .sort((a, b) => a.title.localeCompare(b.title)) ?? []
    )
  }

  get selectedItem() {
    return this.studentItems.find((opt) => opt.id === this.args.excludedStudent?.id)
  }

  selectRouteAction = ({ id }: { id: string }) => {
    const { studentRouteName, classRouteName } = this.args
    resetOutletScroll()
    if (id === 'all' && classRouteName) {
      void this.router.transitionTo(classRouteName)
    } else if (this.router.currentRouteName === studentRouteName) {
      void this.router.replaceWith(studentRouteName, id, { queryParams: { dateRange: undefined } })
    } else if (studentRouteName) {
      void this.router.transitionTo(studentRouteName, id)
    }
  }

  <template>
    <FilteringSelect
      data-test-student-search
      class="bg-white"
      @items={{this.studentItems}}
      @selectedItem={{this.selectedItem}}
      @placeholderText={{t "reporting.dropdownSearchStudents"}}
      @selectAction={{this.selectRouteAction}}
      @includeSelectAll={{@includeSelectAll}}
      @selectAllName={{t "reporting.dropdownSearchAllStudents"}}
    />
  </template>
}

export default StudentSearchComponent
